import { useEffect } from 'react';
import { useSelector, dispatch } from '../redux/store';
import { getActualites } from '../redux/slices/actualites';


export default function useActualites() {
  const { isLoading, actualites, error } = useSelector(state => state.actualites);

  useEffect(() =>{
    dispatch(getActualites())
  },[])
  return {loading:isLoading, actualites, error}
}
